module.exports = __webpack_public_path__ + "img/excel-icon.2649c0c1.svg";